import Vue from 'vue';
import App from './App';
import router from './router';

// ========== 1. ElementUI 按需引入 ==========
import {
  // 布局组件
  Container,
  Header,
  Aside,
  Main,
  Footer,// 基础组件
  Button,
  Input,
  InputNumber,
  Select,
  Option,
  Table,
  TableColumn,
  Dialog,
  Form,
  FormItem,
  Loading,
  Message,
  MessageBox,
  Pagination,
  DatePicker,
  TimePicker,
  TimeSelect,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  MenuItem,
  Submenu,
  Tabs,
  TabPane,
  Row,
  Col,
  Card,
  Tag,
  Tooltip,
  Popover,
  Image,
  Upload,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Slider,
  Switch,
  Transfer,          // 穿梭框
  Breadcrumb,
  BreadcrumbItem,
  Divider,
  Tree,
  Notification
} from 'element-ui';

// 按需引入组件样式
import 'element-ui/lib/theme-chalk/container.css';
import 'element-ui/lib/theme-chalk/header.css';
import 'element-ui/lib/theme-chalk/aside.css';
import 'element-ui/lib/theme-chalk/main.css';
import 'element-ui/lib/theme-chalk/footer.css';
import 'element-ui/lib/theme-chalk/button.css';
import 'element-ui/lib/theme-chalk/input.css';
import 'element-ui/lib/theme-chalk/input-number.css';
import 'element-ui/lib/theme-chalk/select.css';
import 'element-ui/lib/theme-chalk/option.css';
import 'element-ui/lib/theme-chalk/table.css';
import 'element-ui/lib/theme-chalk/table-column.css';
import 'element-ui/lib/theme-chalk/dialog.css';
import 'element-ui/lib/theme-chalk/form.css';
import 'element-ui/lib/theme-chalk/form-item.css';
import 'element-ui/lib/theme-chalk/pagination.css';
import 'element-ui/lib/theme-chalk/date-picker.css';
import 'element-ui/lib/theme-chalk/time-picker.css';
import 'element-ui/lib/theme-chalk/time-select.css';
import 'element-ui/lib/theme-chalk/dropdown.css';
import 'element-ui/lib/theme-chalk/dropdown-menu.css';
import 'element-ui/lib/theme-chalk/dropdown-item.css';
import 'element-ui/lib/theme-chalk/menu.css';
import 'element-ui/lib/theme-chalk/menu-item.css';
import 'element-ui/lib/theme-chalk/submenu.css';
import 'element-ui/lib/theme-chalk/tabs.css';
import 'element-ui/lib/theme-chalk/tab-pane.css';
import 'element-ui/lib/theme-chalk/row.css';
import 'element-ui/lib/theme-chalk/col.css';
import 'element-ui/lib/theme-chalk/card.css';
import 'element-ui/lib/theme-chalk/tag.css';
import 'element-ui/lib/theme-chalk/tooltip.css';
import 'element-ui/lib/theme-chalk/popover.css';
import 'element-ui/lib/theme-chalk/image.css';
import 'element-ui/lib/theme-chalk/upload.css';
import 'element-ui/lib/theme-chalk/checkbox.css';
import 'element-ui/lib/theme-chalk/radio.css';
import 'element-ui/lib/theme-chalk/radio-button.css';
import 'element-ui/lib/theme-chalk/slider.css';
import 'element-ui/lib/theme-chalk/switch.css';
import 'element-ui/lib/theme-chalk/transfer.css';     // 穿梭框样式
import 'element-ui/lib/theme-chalk/breadcrumb.css';
import 'element-ui/lib/theme-chalk/breadcrumb-item.css';
import 'element-ui/lib/theme-chalk/divider.css';
import 'element-ui/lib/theme-chalk/tree.css';
import 'element-ui/lib/theme-chalk/loading.css';
import 'element-ui/lib/theme-chalk/message-box.css';
import 'element-ui/lib/theme-chalk/message.css';
import 'element-ui/lib/theme-chalk/notification.css';
import 'element-ui/lib/theme-chalk/icon.css';

// 注册组件
const components = [
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Button,
  Input,
  InputNumber,
  Select,
  Option,
  Table,
  TableColumn,
  Dialog,
  Form,
  FormItem,
  Pagination,
  DatePicker,
  TimePicker,
  TimeSelect,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Menu,
  MenuItem,
  Submenu,
  Tabs,
  TabPane,
  Row,
  Col,
  Card,
  Tag,
  Tooltip,
  Popover,
  Image,
  Upload,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  RadioButton,
  Slider,
  Switch,
  Transfer,
  Breadcrumb,
  BreadcrumbItem,
  Divider,
  Tree
];

components.forEach(component => {
  Vue.component(component.name,component);
});

// ========== Loading 挂载为 $load ==========
Vue.prototype.$loading = Loading.service;
Vue.directive('loading',Loading.directive);

// MessageBox 服务
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

// ========== 2. API 按需引入 ==========
import * as api from './utils/api';

Vue.prototype.$api = api;

// ========== 3. 配置对象（保持原样）==========
import urls from "./config/urls";

Vue.prototype.$urls = urls;

Vue.config.productionTip = false;

// ========== 4. echarts 异步加载 ==========
Vue.prototype.$echarts = null;
Vue.prototype.$initEcharts = async() => {
  if (!Vue.prototype.$echarts) {
    const echarts = await import(/* webpackChunkName: "echarts" */ 'echarts');
    Vue.prototype.$echarts = echarts;
  }
  return Vue.prototype.$echarts;
};

// ========== 5. 非首屏组件延迟加载 ==========
import(/* webpackChunkName: "org-tree" */ 'vue2-org-tree').then(Vue2OrgTree => {
  Vue.use(Vue2OrgTree.default);
});

// ========== 6. Message 封装 ==========
const messageTypes = [
  'success',
  'info',
  'warning',
  'error'
];

Vue.prototype.$message = function (msg) {
  return Message({message:msg,duration:1000});
};

messageTypes.forEach(type => {
  Vue.prototype.$message[type] = function (msg) {
    return Message[type]({message:msg,duration:1000});
  };
});

// ========== 7. 启动应用 ==========
new Vue({
  el:'#app',router,render:h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js